import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import NoneAnchor from 'components/NoneAnchor'
import { setSort, setStatus } from 'features/dashboard/tree/dashboardTreeSlice'
import useOutsideClick from '../../../utils/hooks/useOutsideClick'

export const TREE_STATUS = {
  ALL: '',
  ON: 'ON',
  OFF: 'OFF',
}

export const TREE_SORT = {
  NAME_ASC: 'name asc',
  NAME_DESC: 'name desc',
  CREATED_DATE_ASC: 'createdDate asc',
  CREATED_DATE_DESC: 'createdDate desc',
  UPDATED_DATE_ASC: 'updatedDate asc',
  UPDATED_DATE_DESC: 'updatedDate desc',
}
const getSortName = sort => {
  if (sort === TREE_SORT.NAME_ASC || sort === TREE_SORT.NAME_DESC) {
    return '이름순'
  } else if (
    sort === TREE_SORT.CREATED_DATE_ASC ||
    sort === TREE_SORT.CREATED_DATE_DESC
  ) {
    return '등록일순'
  } else {
    return '수정일순'
  }
}

const StatusAndSort = () => {
  const dispatch = useDispatch()
  const { status, sort } = useSelector(state => state.dashboard.tree)
  const [open, setOpen] = useState(false)
  const handleToggle = () => {
    setOpen(draft => !draft)
  }
  const handleStatusChange = value => {
    dispatch(setStatus(value))
    close()
  }
  const handleSortChange = value => {
    dispatch(setSort(value))
    close()
  }
  const close = () => {
    setOpen(false)
  }
  const ref = useOutsideClick(close)
  return (
    <div ref={ref} className={classNames('wrap_select', { opt_open: open })}>
      <NoneAnchor className="btn_select" onClick={handleToggle}>
        {status === TREE_STATUS.ALL ? '전체' : status}·{getSortName(sort)}{' '}
        <span
          className={classNames('ico_comm ico_sort', {
            sort_up:
              sort === TREE_SORT.NAME_ASC ||
              sort === TREE_SORT.CREATED_DATE_ASC ||
              sort === TREE_SORT.UPDATED_DATE_ASC,
            sort_down:
              sort === TREE_SORT.NAME_DESC ||
              sort === TREE_SORT.CREATED_DATE_DESC ||
              sort === TREE_SORT.UPDATED_DATE_DESC,
          })}>
          정렬
        </span>
        <span className="ico_comm ico_menu">펼침/닫힘</span>
      </NoneAnchor>
      <strong className="screen_out">선택옵션</strong>
      <div className="opt_list">
        <div className="inner_list">
          <strong className="tit_option">상태</strong>
          <ul className="list_opt sub_listopt">
            <li className={classNames({ on: status === TREE_STATUS.ALL })}>
              <NoneAnchor
                className="link_option"
                onClick={() => handleStatusChange(TREE_STATUS.ALL)}>
                전체
              </NoneAnchor>
            </li>
            <li className={classNames({ on: status === TREE_STATUS.ON })}>
              <NoneAnchor
                className="link_option"
                onClick={() => handleStatusChange(TREE_STATUS.ON)}>
                ON
              </NoneAnchor>
            </li>
            <li className={classNames({ on: status === TREE_STATUS.OFF })}>
              <NoneAnchor
                className="link_option"
                onClick={() => handleStatusChange(TREE_STATUS.OFF)}>
                OFF
              </NoneAnchor>
            </li>
          </ul>
        </div>
        <div className="inner_list">
          <strong className="tit_option">정렬</strong>
          <ul className="list_opt sub_listopt">
            <li
              className={classNames({
                on: sort === TREE_SORT.NAME_ASC || sort === TREE_SORT.NAME_DESC,
              })}>
              <NoneAnchor
                className="link_option"
                onClick={() =>
                  handleSortChange(
                    sort === TREE_SORT.NAME_ASC
                      ? TREE_SORT.NAME_DESC
                      : TREE_SORT.NAME_ASC
                  )
                }>
                이름순
              </NoneAnchor>
              <NoneAnchor
                className="desc_sort"
                onClick={() =>
                  handleSortChange(
                    sort === TREE_SORT.NAME_ASC
                      ? TREE_SORT.NAME_DESC
                      : TREE_SORT.NAME_ASC
                  )
                }>
                <span
                  className={classNames('ico_comm ico_sort', {
                    sort_up:
                      sort === TREE_SORT.NAME_ASC ||
                      (sort !== TREE_SORT.NAME_ASC &&
                        sort !== TREE_SORT.NAME_DESC),
                    sort_down: sort === TREE_SORT.NAME_DESC,
                  })}>
                  정렬
                </span>
              </NoneAnchor>
            </li>
            <li
              className={classNames({
                on:
                  sort === TREE_SORT.CREATED_DATE_ASC ||
                  sort === TREE_SORT.CREATED_DATE_DESC,
              })}>
              <NoneAnchor
                className="link_option"
                onClick={() =>
                  handleSortChange(
                    sort === TREE_SORT.CREATED_DATE_ASC
                      ? TREE_SORT.CREATED_DATE_DESC
                      : TREE_SORT.CREATED_DATE_ASC
                  )
                }>
                등록일순
              </NoneAnchor>
              <NoneAnchor
                className="desc_sort"
                onClick={() =>
                  handleSortChange(
                    sort === TREE_SORT.CREATED_DATE_ASC
                      ? TREE_SORT.CREATED_DATE_DESC
                      : TREE_SORT.CREATED_DATE_ASC
                  )
                }>
                <span
                  className={classNames('ico_comm ico_sort', {
                    sort_up:
                      sort === TREE_SORT.CREATED_DATE_ASC ||
                      (sort !== TREE_SORT.CREATED_DATE_ASC &&
                        sort !== TREE_SORT.CREATED_DATE_DESC),
                    sort_down: sort === TREE_SORT.CREATED_DATE_DESC,
                  })}>
                  정렬
                </span>
              </NoneAnchor>
            </li>
            <li
              className={classNames({
                on:
                  sort === TREE_SORT.UPDATED_DATE_ASC ||
                  sort === TREE_SORT.UPDATED_DATE_DESC,
              })}>
              <NoneAnchor
                className="link_option"
                onClick={() =>
                  handleSortChange(
                    sort === TREE_SORT.UPDATED_DATE_ASC
                      ? TREE_SORT.UPDATED_DATE_DESC
                      : TREE_SORT.UPDATED_DATE_ASC
                  )
                }>
                수정일순
              </NoneAnchor>
              <NoneAnchor
                className="desc_sort"
                onClick={() =>
                  handleSortChange(
                    sort === TREE_SORT.UPDATED_DATE_ASC
                      ? TREE_SORT.UPDATED_DATE_DESC
                      : TREE_SORT.UPDATED_DATE_ASC
                  )
                }>
                <span
                  className={classNames('ico_comm ico_sort', {
                    sort_up:
                      sort === TREE_SORT.UPDATED_DATE_ASC ||
                      (sort !== TREE_SORT.UPDATED_DATE_ASC &&
                        sort !== TREE_SORT.UPDATED_DATE_DESC),
                    sort_down: sort === TREE_SORT.UPDATED_DATE_DESC,
                  })}>
                  정렬
                </span>
              </NoneAnchor>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default StatusAndSort
